module.exports = __webpack_public_path__ + "static/img/news-23.a8bfbbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/news-23.jpg
// module id = f/W1
// module chunks = 5